// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

// Vuetify
import { createVuetify } from 'vuetify';

import { VTextField } from 'vuetify/components/VTextField'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  aliases: {
    VTextSearch: VTextField,
  },
  defaults: {
    VTextField: {
      variant: 'underlined',
      density: 'compact',
    },
    VTextSearch: {
      variant: 'underlined',
      density: 'compact',
      label: 'Search',
      prependIcon: 'mdi-magnify',
      class: 'mx-3 mb-2',
      hideDetails: true,
    },
    VTextarea: {
      variant: 'underlined',
      density: 'compact',
    },
    VSelect: {
      variant: 'underlined',
      density: 'compact',
      menuProps: { maxWidth: '100vw' },
    },
    VCombobox: {
      variant: 'underlined',
      density: 'compact',
      menuProps: { maxWidth: '100vw' },
    },
    VAutocomplete: {
      variant: 'underlined',
      density: 'compact',
      menuProps: { maxWidth: '100vw' },
    },
    VFileInput: {
      variant: 'underlined',
      density: 'compact',
    },
    VToolbar: {
      color: '#fff',
      flat: true,
    },
    VContainer: {
      fluid: true,
    },
  },
});
